export default "__VITE_ASSET__oXVGZPgi__"